import { cn } from '../cn'

/**
 * A region of the sheet. Separated by a rule rather than lifted by a shadow —
 * only genuinely floating elements get elevation.
 */
export function Panel({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <section
      className={cn('rounded-[var(--radius-panel)] border border-rule bg-surface', className)}
      {...props}
    />
  )
}

export function PanelHeader({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <header
      className={cn('flex items-center justify-between gap-3 border-b border-rule px-4 py-2.5', className)}
      {...props}
    />
  )
}

export function PanelTitle({ className, ...props }: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h2 className={cn('text-lg font-semibold text-ink', className)} {...props} />
}

export function PanelBody({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('p-4', className)} {...props} />
}
